/**
 * @author Ariel
 * @description 个人路径任务完成明细
 * @Date 2023/11/09
 */
import React from "react";
import { connect } from "dva";
import { framework_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from "./column";
import { mapStateToProps, handleExport } from "../../utils";

const { WizContainer, WizReduxTemplate } = framework_tool;

class PersonalPathTaskCompletion extends WizContainer {
  componentName = "PersonalPathTaskCompletion";

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: handleExport.bind(this, { title: "个人路径任务完成明细", column }),
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />;
  }
}

export default connect(
  mapStateToProps.bind(this, {
    nameSpace: "pathReport",
    method: "getPageListTaskDetail",
  })
)(PersonalPathTaskCompletion);
